import { Component, Input } from '@angular/core';

@Component({
  selector: 'hawk-progress-bar',
  imports: [],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {

  @Input() progress: number;

}
